import React from 'react';
import { observer } from 'mobx-react-lite';
import { AutoMessage } from '../molecules/AutoMessage';
import { useRootStore } from '../../App';
import styled from 'styled-components';
import { FaqResetButton } from '../atoms/FaqResetButton';

const CategoryReselectDiv = styled.div<{
  hide: boolean;
  isWide: boolean;
}>`
  padding: 8px 20px 8px 20px;
  width: 100%;
  content: '';
  clear: both;
  display: ${(props) => (props.hide ? 'none' : 'block')};
`;

export const AutoMessages = observer(() => {
  const CATEGORY_RE_SELECT = 'カテゴリー再選択';
  const root = useRootStore();
  const { messageDivRef } = root.inquiryPageStore;
  const { isWide } = root.layoutStore;
  const {
    sortedAutoMessages,
    getResponse,
    isCategorySelected,
    isFaqUnresolved,
    isFaqResolvedAndNoMoreQuestion,
  } = root.faqStore;
  const { user } = root.userStore;

  const { messagesCount } = root.messageStore;

  let lastRightMessageIndex = 0;
  sortedAutoMessages.forEach((e, index) => {
    if (e.messageSender) {
      lastRightMessageIndex = index;
    }
  });

  return (
    <div>
      {sortedAutoMessages.map((message, index) => {
        return (
          <AutoMessage
            key={`auto-message-${index}`}
            isWide={isWide}
            userId={user.userId}
            message={message}
            childrenContainerDivRef={messageDivRef}
            messageDivRef={messageDivRef}
            clickHandler={getResponse}
            addRefDivForAutoScroll={
              messagesCount === 0 && index === lastRightMessageIndex
            }
          />
        );
      })}
      <CategoryReselectDiv
        hide={
          !isCategorySelected ||
          isFaqUnresolved ||
          isFaqResolvedAndNoMoreQuestion
        }
        isWide={isWide}
      >
        {/* FIXME: copied from ih-front, but...should be renamed??*/}
        <FaqResetButton
          onClick={(e: MouseEvent) => {
            e.preventDefault();
            getResponse('', { id: -1, value: CATEGORY_RE_SELECT });
          }}
          children={`${CATEGORY_RE_SELECT}`}
        />
      </CategoryReselectDiv>
    </div>
  );
});
